import { createRouter, createWebHistory } from '@ionic/vue-router';
import navigation from './navigation';
import { reloadOnceOnStaleChunk } from '@/utils/staleChunkReload';
import {
  resolveKitchenKioskRedirect,
  syncKitchenPwaManifest,
} from '@/utils/kitchenKiosk';
import { isKitchenRoute } from '@/utils/authUtils';
import { isKitchenKioskActive, resolveKitchenKioskTarget } from '@/utils/kitchenKiosk';
import { getKitchenBindToken } from '@/utils/kitchenBinding';
import { syncPartnerPwaHead } from '@/utils/partnerPwaHead';

const defaultEntryPath = () => {
  if (isKitchenKioskActive()) {
    const bind = getKitchenBindToken();
    if (bind) {
      return `/kueche?bind=${encodeURIComponent(bind)}`;
    }
    return '/kueche';
  }
  return '/login/main';
};

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      redirect: defaultEntryPath,
    },
    ...navigation,
    {
      path: '/:pathMatch(.*)*',
      redirect: defaultEntryPath,
    },
  ],
});

router.beforeEach((to, from, next) => {
  syncKitchenPwaManifest(to);
  if (isKitchenKioskActive() && (to.path === '/login' || to.path.startsWith('/login/'))) {
    next(resolveKitchenKioskTarget());
    return;
  }
  const kioskRedirect = resolveKitchenKioskRedirect(to);
  if (kioskRedirect) {
    next(kioskRedirect);
    return;
  }
  next();
});

router.afterEach((to) => {
  syncKitchenPwaManifest(to);
  syncPartnerPwaHead(to);
  if (!isKitchenRoute(to) && !isKitchenKioskActive()) {
    document.title = 'Ollaa Partner';
  }
});

router.onError((error) => {
  reloadOnceOnStaleChunk(error);
});

export default router;
